import type { AppFlowsContainer } from '#flows.js';
import type { FirestoreContainer } from './FirestoreContainer.js';

import { createContainer } from '@elara/core/di';

import { createClientPaymentMethodModel } from '#models/PaymentMethodModel.js';

/** DI container for the wallet (saved payment methods). Exposes the reactive `ClientPaymentMethod` model. */
export function createPaymentMethodsContainer(flows: AppFlowsContainer, firestore: FirestoreContainer) {
  const $wallet = createContainer('wallet').providedLazy('ClientPaymentMethod', () =>
    createClientPaymentMethodModel(flows, firestore),
  );
  return $wallet;
}

export type $PaymentMethodsContainer = ReturnType<typeof createPaymentMethodsContainer>;
export type PaymentMethodsContainer = $PaymentMethodsContainer['use'];
